export default "__VITE_ASSET__2beaef6a__"